var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechBubbleLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 485,
    height: 367,
    viewBox: "0 0 485 367",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5213_236776)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.928 310.772C367.065 318.244 478.878 255.086 483.669 169.705C488.461 84.3234 384.417 9.05132 251.28 1.57966C118.144 -5.89201 6.33057 57.2661 1.53896 142.647C-2.72798 218.679 79.3111 286.695 191.345 305.955L242.106 354.15L217.774 309.522C223.107 310.049 228.493 310.467 233.928 310.772Z",
    fill: "#FBFBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.669 169.705L483.17 169.677L483.669 169.705ZM233.928 310.772L233.9 311.271L233.928 310.772ZM251.28 1.57966L251.252 2.07887L251.28 1.57966ZM1.53896 142.647L2.03818 142.675L1.53896 142.647ZM191.345 305.955L191.689 305.592L191.579 305.488L191.429 305.462L191.345 305.955ZM242.106 354.15L241.762 354.513L242.545 353.911L242.106 354.15ZM217.774 309.522L217.823 309.025L216.883 308.932L217.335 309.762L217.774 309.522ZM483.17 169.677C480.787 212.139 451.787 249.145 406.682 274.623C361.583 300.097 300.444 314.004 233.956 310.273L233.9 311.271C300.55 315.012 361.885 301.076 407.174 275.494C452.458 249.915 481.76 212.651 484.169 169.733L483.17 169.677ZM251.252 2.07887C317.74 5.81016 376.939 26.4706 418.905 56.8312C460.876 87.1956 485.553 127.214 483.17 169.677L484.169 169.733C486.577 126.814 461.628 86.5058 419.491 56.021C377.348 25.5323 317.958 4.82082 251.308 1.08044L251.252 2.07887ZM2.03818 142.675C4.42119 100.213 33.4213 63.2067 78.5261 37.729C123.625 12.2545 184.765 -1.65241 251.252 2.07887L251.308 1.08044C184.659 -2.65994 123.324 11.2764 78.0343 36.8583C32.7505 62.4371 3.44835 99.7007 1.03975 142.619L2.03818 142.675ZM191.429 305.462C135.484 295.844 87.0536 274.057 53.1532 245.21C19.2518 216.362 -0.0839621 180.489 2.03818 142.675L1.03975 142.619C-1.10506 180.837 18.4453 216.989 52.5051 245.971C86.5659 274.955 135.172 296.805 191.26 306.448L191.429 305.462ZM191 306.317L241.762 354.513L242.451 353.788L191.689 305.592L191 306.317ZM242.545 353.911L218.213 309.283L217.335 309.762L241.667 354.39L242.545 353.911ZM233.956 310.273C228.528 309.968 223.149 309.551 217.823 309.025L217.725 310.02C223.065 310.547 228.458 310.966 233.9 311.271L233.956 310.273Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5213_236776",
    x: 0.879883,
    y: 0.479492,
    width: 483.449,
    height: 366.034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5213_236776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5213_236776",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleLarge);
export default __webpack_public_path__ + "static/media/speechBubbleLarge.bb649858d3f70ff6e1c7ce1c2519827b.svg";
export { ForwardRef as ReactComponent };